var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-start align-center note"},[_c('v-icon',[_vm._v("mdi-alert-circle")]),_c('span',{staticClass:"ml-2"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }